import React, { useEffect } from 'react';
import '../Assets/Css/home.css';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaSearch, FaDraftingCompass, FaCogs, FaChalkboardTeacher } from 'react-icons/fa';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChartBar, FaUsers, FaBoxes, FaUserTie, FaIndustry, FaCashRegister, FaProjectDiagram, FaHeadset, } from "react-icons/fa";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { Helmet } from 'react-helmet';
import leftaboutsection from '../Assets/Image/trident-home-about.jpg';
import { FaWineGlassAlt, FaLeaf, FaHeart } from 'react-icons/fa';
import erp from '../Assets/Image/Erpsystem1.avif'
import crm from '../Assets/Image/crm2.avif'
import hrm from '../Assets/Image/hrms1.avif'
import production from '../Assets/Image/production3.avif'
import client1 from '../Assets/Image/client1.png'
import client2 from '../Assets/Image/client2.png'
import client3 from '../Assets/Image/client3.png'
import client14 from '../Assets/Image/client14.png'
import client5 from '../Assets/Image/client5.png'
import client6 from '../Assets/Image/client6.png'
import client13 from '../Assets/Image/client13.png'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useNavigate } from 'react-router-dom';

export default function HomePage() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
    AOS.refresh();
  }, []);

  const navigate = useNavigate();

  const iconFeatures = [
    {
      title: "Customized ERP Implementation",
      description:
        "We tailor Enterprise Resource Planning systems to meet unique organizational workflows and streamline cross-functional processes.",
      icon: <FaChartBar size={45} color="#fff" />,
    },
    {
      title: "Integrated CRM Strategies",
      description:
        "Drive customer engagement and loyalty with centralized data, automation, and actionable insights for smarter sales and support.",
      icon: <FaUsers size={45} color="#fff" />,
    },
    {
      title: "Smart Distribution & Resource Planning",
      description:
        "Optimize supply chain and resource management with intelligent forecasting, inventory control, and planning modules.",
      icon: <FaBoxes size={45} color="#fff" />,
    },
    {
      title: "Advanced HRMS Integration",
      description:
        "Simplify workforce management with solutions for hiring, attendance, payroll, compliance, and performance tracking.",
      icon: <FaUserTie size={36} color="#fff" />,
    },
    {
      title: "Shopfloor Automation",
      description:
        "Enable real-time visibility and control over production environments, minimizing delays and enhancing quality assurance.",
      icon: <FaIndustry size={36} color="#fff" />,
    },
    {
      title: "Retail Point-of-Sale Solutions",
      description:
        "Deliver seamless customer experiences through integrated POS, inventory, and billing systems across physical and digital stores.",
      icon: <FaCashRegister size={36} color="#fff" />,
    },
    {
      title: "End-to-End Production Planning",
      description:
        "Forecast, schedule, and manage production cycles to maximize resource efficiency and minimize downtime.",
      icon: <FaProjectDiagram size={45} color="#fff" />,
    },
    {
      title: "Robust Support & Helpdesk Systems",
      description:
        "Ensure business continuity with responsive technical support, ticketing systems, and 24/7 availability.",
      icon: <FaHeadset size={45} color="#fff" />,
    },
    {
      title: "Professional Training & Enablement",
      description:
        "We don’t just deploy — we train. Empower your workforce with practical, hands-on learning for every product we implement.",
      icon: <FaChalkboardTeacher size={45} color="#fff" />,
    },
  ];

  const flavors = [
    {
      title: "Enterprise Resource Planning (ERP)",
      text: "Centralized system to manage finance, inventory, procurement, and more in real-time.",
      image: erp,
      alt: "ERP System",
      col: 3,
      link: "/ourproducts"
    },
    {
      title: "Customer Relationship Management (CRM)",
      text: "Track leads, automate follow-ups, and enhance customer engagement across your pipeline.",
      image: crm,
      alt: "CRM Platform",
      col: 3,
      link: "/ourproducts"
    },
    {
      title: "Human Resource Management System",
      text: "Streamline payroll, attendance, performance tracking, and employee lifecycle management.",
      image: hrm,
      alt: "HRMS Software",
      col: 3,
      link: "/ourproducts"
    },
    {
      title: "Production Planning & Shopfloor Control",
      text: "Optimize manufacturing schedules, track labor/machines, and ensure output efficiency.",
      image: production,
      alt: "Production Control",
      col: 3,
      link: "/ourproducts"
    },
  ];

  const testimonials = [
    "Trident Software Services transformed our workflow—efficient, intuitive, and scalable.",
    "Their team is not just tech-savvy, but also incredibly supportive and responsive.",
    "We’ve seen a 40% boost in productivity since implementing Trident’s ERP system.",
    "Professionalism and innovation define our experience with Trident. Highly recommended!",
    "From planning to execution, Trident delivered solutions that matched our business vision perfectly.",
  ];


  const approachPoints = [
    {
      title: "Evaluate Business Objectives",
      icon: <FaSearch size={50} className="approch-icon" />,
      description:
        "We analyze your business goals to align ERP, HRMS, and other solutions with your core needs.",
      link: "/contact"
    },
    {
      title: "Design Tailored Solutions",
      icon: <FaDraftingCompass size={50} className="approch-icon" />,
      description:
        "We craft integrated solutions — from CRM to Shopfloor Control — suited to your workflow.",
      link: "/services"
    },
    {
      title: "Implement & Integrate",
      icon: <FaCogs size={50} className="approch-icon" />,
      description:
        "Our team deploys and connects systems like Production Planning with minimal disruption.",
      link: "/implementation"
    },
    {
      title: "Train, Support & Scale",
      icon: <FaChalkboardTeacher size={50} className="approch-icon" />,
      description:
        "We provide training and support to help you scale and adapt systems as your business grows.",
      link: "/training"
    }
  ];

  const companyLogos = [
    { src: client1, alt: "GE" },
    { src: client2, alt: "Intel" },
    { src: client3, alt: "Brown & Toland Physicians" },
    { src: client13, alt: "Gigamon" },
    { src: client14, alt: "Cognizant" },
    { src: client5, alt: "Gigamon" },
    { src: client6, alt: "Cognizant" },
  ];

  const settings = {
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    speed: 10000,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    pauseOnHover: false,
    swipe: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };


  return (
    <>
      <div>

        <Helmet>
          {/* Basic SEO */}
          <title>Trident Software Services | Empowering Innovation Through Technology</title>
          <meta
            name="description"
            content="Trident Software Services offers scalable, intelligent, and professional-grade digital solutions to businesses, startups, and enterprises across industries."
          />
          <meta
            name="keywords"
            content="Trident Software Services, software development, IT consulting, enterprise solutions, startup tech, digital transformation, custom software"
          />
          <meta name="author" content="Trident Software Services" />

          {/* Open Graph / Facebook */}
          <meta property="og:title" content="Trident Software Services | Driving Business Growth with Tech" />
          <meta
            property="og:description"
            content="Partner with Trident to build reliable, scalable, and innovative tech solutions for your business needs."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tridentsoftwaresolutions.com/" />
          <meta
            property="og:image"
            content="https://tridentsoftwaresolutions.com/images/trident-banner.jpg"
          />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Trident Software Services | Transforming Ideas into Innovation" />
          <meta
            name="twitter:description"
            content="Custom IT services and solutions crafted to elevate startups, enterprises, and consultants into digital leaders."
          />
          <meta
            name="twitter:image"
            content="https://tridentsoftwaresolutions.com/images/trident-home-img.jpg"
          />

          {/* Canonical */}
          <link rel="canonical" href="https://tridentsoftwaresolutions.com/" />
        </Helmet>


        <div className="banner1-section d-flex  align-items-center justify-content-center">
          <div className="banner1-overlay text-center">
            <h2 className="banner1-title" data-aos="zoom-in" data-aos-delay="300">
              Transforming Businesses with Smart, Scalable, and Streamlined Software Services
            </h2>
            <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">From ERP to Shopfloor Control, we build enterprise-ready systems tailored to your success.</p>
            <Button variant="light" className="banner1-button mt-5" href='ourproducts'
              data-aos="zoom-in" data-aos-delay="300">
              Explore Products <IoArrowForwardCircleOutline size={30} style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} />
            </Button>
          </div>
        </div>

        <section className="about-section " style={{ marginTop: '40px' }}>
          <Container>
            <Row className="text-center section-heading" data-aos="fade-down" data-aos-delay="100">
              <Col>
                <h3 className="fw-bold section-title">
                  About Trident Software Services
                  <span className="title-decoration mb-4"> </span>
                </h3>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={5} className="mb-4 mb-md-0" data-aos="zoom-in" data-aos-delay="200">
                <img
                  src={leftaboutsection}
                  alt="trident"
                  className="img-fluid rounded"
                />
              </Col>

              <Col xs={12} md={7} className="aboutmid text-center text-md-start" data-aos="fade-up" data-aos-delay="300">
                {/* <h3 className="fw-bold mb-3">
                  About Trident Software Services
                </h3> */}
                <p className="text-muted" style={{ textAlign: 'justify' }}>
                  At <strong className='about-home-bold'>Trident Software Services</strong>, we believe in empowering businesses through smart, scalable, and future-ready technology. Whether you’re a nimble startup looking to scale rapidly, a mid-sized firm seeking efficiency, or a global enterprise navigating complexity, our solutions are tailored to fit your vision.
                </p>
                <p className="text-muted" style={{ textAlign: 'justify' }}>
                  From Enterprise Resource Planning (ERP) to Customer Relationship Management (CRM), Human Resource Management Systems (HRMS), and Shopfloor Automation, Trident is your trusted ally in enterprise digitization.
                </p>


                <div className='' data-aos="zoom-in-up" data-aos-delay="400">
                  <Button className='watchnowbtn' href='/diversity'>Watch Our Story</Button>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="py-5 icon-padding-control">
          <Container fluid className="homeabout text-center pb-5">
            <h3 className="fw-bold section-title2 text-center my-3">
              Our Approach at Trident Software Services
              <span className="title-decoration2"> </span>
            </h3>

            <div className="section-underline mx-auto mb-4"></div>

            <Row className="justify-content-center px-5 text-center">
              {approachPoints.map(({ title, icon, description }, index) => (
                <Col
                  key={index}
                  xs={6}
                  sm={4}
                  md={3}
                  lg={3}
                  className="mb-4 d-flex flex-column align-items-center"
                  data-aos="zoom-in"
                  data-aos-delay={100 * (index + 1)}
                >
                  <div className="icon-wrapper position-relative">
                    <div className="circle-icon d-flex align-items-center justify-content-center">
                      {icon}
                    </div>

                    {/* Hover Overlay */}
                    <div className="hover-overlay">
                      <p className="overlay-text">{description}</p>
                    </div>
                  </div>

                  {/* Title below icon */}
                  <div className="fw-semibold small-label text-white mt-2">{title}</div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className='product-section'>
          <Container >

            <Row className="text-center section-heading" data-aos="zoom-in" data-aos-delay="200">
              <Col>
                <h3 className="fw-bold section-title">
                  Products We Offer
                  <span className="title-decoration"> </span>
                </h3>
                <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                  Discover our innovative, professional, and feature-rich enterprise solutions—designed to drive performance, precision, and business success.
                </p>
              </Col>
            </Row>
            <Row className='justify-content-center'>
              {flavors.map((service, index) => (
                <Col lg={3} md={4} sm={6} xs={6} data-aos="zoom-in" className="mt-4 mb-0 d-flex justify-content-center align-items-center" key={index}>
                  <div className="project-card position-relative glass-card overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="rounded project-img"
                    />
                    <div className="badge-container position-absolute top-0 start-0 m-2">
                      {service.tags?.map((tag, i) => (
                        <span className="badge bg-dark me-1" key={i}>
                          {tag}
                        </span>
                      ))}
                    </div>
                    <div className="project-caption p-3 text-white position-absolute bottom-0 start-0 w-80 bg-gradient">
                      <h5 className="fw-semibold mb-1">{service.title}</h5>
                      <a
                        className="quick-view-btn"
                        onClick={() => navigate(service.link)}
                      >
                        Quick View →
                      </a>
                    </div>
                  </div>
                </Col>
              ))}

              <Button variant="light" className="banner1-button mt-5" href='ourproducts' style={{width:'200px'}}>
                More Products <IoArrowForwardCircleOutline size={30} style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} />
              </Button>
            </Row>
          </Container>
        </section>

        <section className="ctasection text-white d-flex align-items-center" >
          <div className="container">
            <div className="row align-items-center" data-aos="zoom-in" data-aos-delay="200">
              <div className="col-12">
                <div className="ctasection-content p-4 p-md-5 text-center">
                  <h2
                    className="fw-bold mb-4"
                    style={{
                      fontFamily: "'Playfair Display', serif",
                      fontSize: '2.5rem',
                      letterSpacing: '1px',
                    }}
                  >
                    Empower Your Business Journey
                  </h2>
                  <p
                    className="mb-4"
                    style={{
                      fontSize: '1.15rem',
                      lineHeight: '1.6',
                      color: '#f8f1e7',
                      maxWidth: '750px',
                      margin: '0 auto',
                    }}
                  >
                    From ERP and CRM to HRMS, POS, and beyond — our scalable solutions are built to help you streamline operations, boost performance, and grow confidently.
                  </p>
                  <Button variant="light" className="banner1-button mt-3 " href='/ourproducts'
                    data-aos="zoom-in" data-aos-delay="300">
                    Explore Our Products <IoArrowForwardCircleOutline size={30} style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-5 bg-light text-center">
          <Row className="text-center section-heading mb-4 m-0" data-aos="zoom-in" data-aos-delay="200">
            <Col>
              <h3 className="fw-bold section-title">
                We connect great talent to great companies
                <span className="title-decoration"> </span>
              </h3>
              {/* <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                Discover our innovative, professional, and feature-rich enterprise solutions—designed to drive performance, precision, and business success.
              </p> */}
            </Col>
          </Row>
          <div className="container mt-4">
            <Slider {...settings}>
              {companyLogos.map((logo, index) => (
                <div key={index}>
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    style={{
                      // maxWidth: "120px",
                      margin: "0 auto",
                      height: "80px",
                      position: 'fill'
                    }}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </section>



        <section className="pt-5 icon-padding-control">
          <div className="d-flex justify-content-center  icon-section experties-icons">
            <Container>
              <Row
                className="text-center section-heading p-4"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <Col>
                  <h3 className="fw-bold text-white section-title">
                    Our Areas of Expertise
                    <span className="title-decoration"></span>
                  </h3>
                  <p className="mx-auto" style={{ maxWidth: 600, color: '#ffcc99' }}>
                  </p>
                </Col>
              </Row>

              <Row className="g-4 justify-content-center">
                {iconFeatures.map((feature, index) => (
                  <Col
                    key={index}
                    md={3}
                    className="text-center icon-item d-flex  align-items-center"
                    data-aos="fade-up" data-aos-delay="100"
                  >
                    {feature.icon}
                    <div className='flex-column ms-2'>
                      <h5 className="mt-3"> {feature.title} </h5>
                      {/* <p> {feature.description} </p> */}
                    </div>

                  </Col>
                ))}
              </Row>
            </Container>
          </div>
        </section>




        <section className="testimonial-carousel-section my-5">
          <div className="container py-3 ">
            <Row className="align-items-center justify-content-center flex-md-row m-0">
              <h3 className="fw-bold text-center section-title">
                Empowering Innovation Through Experience
                <span className="title-decoration mb-2"></span>
              </h3>
              <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                Hear what our clients say about transforming their business with Trident Software Services.
              </p>
              <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

                <Swiper
                  modules={[Autoplay, Pagination, Navigation]}
                  spaceBetween={30}
                  loop={true}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  pagination={{ clickable: true }}
                  navigation={true}
                  className="testimonial-swiper"
                >
                  {testimonials.map((text, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="stars mb-1">
                        {[...Array(5)].map((_, i) => (
                          <FaStar key={i} color="#d23f57" />
                        ))}
                      </div>
                      <p className="testimonial-quote">
                        <span className="quote-mark">“</span>
                        {text}
                        <span className="quote-mark">”</span>
                      </p>
                      <p className="author-name">Anonymous</p>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    </>
  );
}
